export default __webpack_public_path__ + "images/Latin-American.ca1839.jpg";